import { render, staticRenderFns } from "./UserTablesCorporate.vue?vue&type=template&id=110bfbac"
import script from "./UserTablesCorporate.vue?vue&type=script&lang=js"
export * from "./UserTablesCorporate.vue?vue&type=script&lang=js"
import style0 from "./UserTablesCorporate.vue?vue&type=style&index=0&id=110bfbac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports